import { AgGridReact } from "ag-grid-react";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

function AgGridTable({ rowData, columnDefs, defaultColDef, loading, context, onRowClicked }) {
  const { t } = useTranslation();

  return(
    <div className="ag-theme-alpine" style={{ flex: 1, minHeight: 0 }}>
      <AgGridReact
        enableRtl={i18n.language === 'ar'}
        rowData={rowData}
        columnDefs={columnDefs}
        defaultColDef={defaultColDef}
        animateRows={true}
        loading={loading}
        context={context}
        suppressCellFocus={true}
        overlayNoRowsTemplate={ t('common.noData') }
        overlayLoadingTemplate={ t('common.loading') }
        onRowClicked={onRowClicked}
      />
    </div>
  );
}

export default AgGridTable;